/**
 * Role detection utility — decodes custom:role from Cognito id_token.
 *
 * Security notes:
 *   - No token verification here — API Gateway validates the JWT.
 *   - This is purely for frontend routing decisions (which layout/nav to render).
 *   - Role claims are server-authoritative (security.md §1).
 */

export type AppRole = 'user' | 'mentor' | 'admin';

/**
 * Extracts the `custom:role` claim from a Cognito id_token JWT payload.
 * Returns 'mentor' or 'admin' if present; defaults to 'user' for missing,
 * unknown, or malformed tokens (least-privilege fallback — R1.5).
 */
export function decodeRoleFromToken(idToken: string): AppRole {
  try {
    const payload = JSON.parse(atob(idToken.split('.')[1]));
    const role = payload['custom:role'];
    if (role === 'mentor' || role === 'admin') return role;
    return 'user';
  } catch {
    return 'user';
  }
}
